module.exports = "/images/collect-customer-data.svg?41d48a9163cf073440277f8187a611fc";